import $ = require("jquery");
import * as Controls from "./Controls";
//import TraceKit = require("tracekit");
//import StackTrace = require("stacktrace-js");
import moment = require("moment");
import _ = require("underscore");
import { INetIdRealmPair } from "../models/iNetIdRealmPair";



interface IIFormBuilderUrlSettings {
    validateCfoapal: string;
    validateEventSession: string;
    resolveNetId: string;
    validateRegex: string;
    resolveCrnTermCode: string;
}
interface IFormBuilderGlobalSettings {
    urls: IIFormBuilderUrlSettings;
}

export function globalPageData() {
    var pageData = <IFormBuilderGlobalSettings>{
        urls: <IIFormBuilderUrlSettings>{
            validateEventSession: null,
            resolveNetId: null,
            resolveCrnTermCode: null
        }
    };

    $.extend(pageData, window["formBuilderGlobalSettings"]);
    return pageData;
}

/*function logError(uniqueData) {
    function formatStackTrace(stack) {
        function formatStackLine(stackLine) {
            if (stackLine && stackLine.func) {
                return "at " + stackLine.func + " in " + stackLine.url + ": " + stackLine.line;
            } else {
                return stackLine;
            }
        }

        if (stack && stack.length && stack.length > 0) {
            const lines = [];
            let i;
            const length = stack.length;
            for (i = 0; i < length; i += 1) {
                lines.push(formatStackLine(stack[i]));
            }
            return lines.join('\r\n');
        }
        return null;
    };


    let message, url, lineNumber, stackTrace, useragent;
    message = "";
    url = "";
    lineNumber = "";
    useragent = "";
    stackTrace = null;

    try {
        if (!uniqueData.stack) {
            uniqueData.stack = (new Error('make stack'))["stack"];
            if (uniqueData.stack) {
                uniqueData.stack = uniqueData.stack.toString();
            }
        }
    } catch (e) {
        //swallow any errors that happen while creating the stack trace
    }

    if (uniqueData) {
        if (uniqueData.message) {
            message = uniqueData.message;
        }
        if (uniqueData.url) {
            url = uniqueData.url;
        }
        if (uniqueData.useragent) {
            useragent = uniqueData.useragent;
        }
        if (uniqueData.stack && typeof uniqueData.stack !== "string" && uniqueData.stack.length && uniqueData.stack[0]) {
            if (uniqueData.stack[0].line) {
                lineNumber = uniqueData.stack[0].line;
            }

            stackTrace = formatStackTrace(uniqueData.stack);

        }
    }
    if (!stackTrace) {
        if (typeof uniqueData !== 'string') {
            stackTrace = JSON.stringify(uniqueData);
        } else
            stackTrace = uniqueData;
    }

    if (window["errorReportingUrl"] !== undefined && window["errorReportingUrl"]) {
        $.post(window["errorReportingUrl"], { errorMessage: message, url: url, lineNumber: lineNumber, stackTrace: stackTrace, useragent: useragent }, null, "JSON");
    }
}*/

//   TraceKit.report.subscribe(logError);

export function parseDate(value) {
    return Date.parse(value);
}

export function formatTime(value?) {
    if (value) {
        if (!value.getHours) {
            value = Date.parse(String(value));
        }
        if (value) {
            return value.format("hh:MM tt");
        }
    }
    return null;
}

export function formatDate(value?) {
    if (value) {
        if (!value.getHours) {
            value = Date.parse(String(value));
        }
        if (value) {
            return value.format("yyyy-mm-dd");
        }
    }
    return null;
}

export function getPageUrl() {
    try {
        if (window && window.location && window.location.href) {
            return window.location.href;
        }
    } catch (err) {
        //swallow error if unavailable
    }
    return null;
}

export function normalizeArray<T>(array: Array < T >, indexKey: keyof T) {
    const normalizedObject: any = {}
    for (let i = 0; i < array.length; i++) {
        const key = array[i][indexKey]
        normalizedObject[key] = array[i]
    }
    return normalizedObject as { [key: string]: T }
}

export function reportError(messageSource: string, message: string, url?: string, lineNumber?, stackTrace?) {
    if (window["errorReportingUrl"] !== undefined && window["errorReportingUrl"]) {
        if (!url) {
            url = this.getPageUrl();
        }
        message = "Message source: " + messageSource + "\r\n" + message;
        $.post(window["errorReportingUrl"], { errorMessage: message, url: url, lineNumber: lineNumber, stackTrace: stackTrace }, null, "JSON");
    }
}

export function reportMessageResultErrorSilent(messageSource, data?) {
    let message = null;
    if (data) {
        try {
            message = JSON.stringify(data);
            data = null;
        } catch (stEx) {
            message = null;
        }
    }
    if (data) {
        if (data.Message) {
            message = data.Message;
        } else if (data.responseText) {
            message = data.responseText;
        } else if (data.statusText) {
            message = data.statusText;
        } else {
            message = data;
        }
    }
    if (!message) {
        message = "no message available";
    }

    //let url, lineNumber;
    //url = null;
    //lineNumber = null;

    //StackTrace.get().then(function (stackframes) {
    //    var stringifiedStack = stackframes.map(function (sf) {
    //        return sf.toString();
    //    }).join('\r\n');
    //    reportError(messageSource, message, url, lineNumber, stringifiedStack);

    //}, function (err) {
    //    reportError(messageSource, message);
    //});
}

export function flashContainer(target, delay?: number) {
    if (!delay) {
        delay = 5000;
    }
    $(target).fadeIn("fast");
    window.setTimeout(() => { $(target).fadeOut("slow"); }, delay);
};

export function flashModalContainer(target, delay?: number) {
    if (!delay) {
        delay = 5000;
    }
    $(target).fadeIn("fast");
    window.setTimeout(() => { $(target).fadeOut("slow").remove(); }, delay);
};

export function reportMessageResultError(data, message?, details?) {
    reportMessageResultErrorSilent("reportMessageResultError", data);
    message = message || "Error occurred";
    if (details === undefined) {
        details = "An error occurred and has been reported to the application development team.";
    }
    let titleContainer;
    const dialog = $(".modal:visible");
    const isModal = dialog.length > 0;
    if (isModal) {
        const containerId = _.uniqueId('errorContainer_');
        titleContainer = "<div id='" + containerId + "' style='display: none;' class=\"alert alert-danger\">";
        titleContainer += '<h3>' + message + '</h3>';
        if (details) {
            titleContainer += details;
        }
        titleContainer += "</div>";
        dialog.find("div.modal-body").prepend(titleContainer);
        flashModalContainer($("#" + containerId));
    } else {
        //console.log("notifying user");
        Controls.displayErrorMessage(details, message);
    }

}

export function reportErrorSilent(error) {
    // noop
    //try {
    //    //var TraceKit = window["TraceKit"];
    //    //TraceKit.report(error);
    //} catch (tce) { }
}

export function isJsonDate(value): boolean {
    if (value !== null && typeof (value) === "string") {
        if (value.match(/^\/Date\(/) !== null) {
            return true;
        }
    }
    return false;
}

export function parseJsonDate(value) {
    if (isJsonDate(value)) {
        return new Date(parseInt(value.replace(/\/Date\((\d+)\)\//gi, "$1")));
    }
    return value;
}

let _validDateFormats = null;

function getDateFormats() {
    if (_validDateFormats) {
        return _validDateFormats;
    } else {
        _validDateFormats = [];
        const dateFormats = ["M/D/YYYY", "YYYY-M-DD", "YYYY/M/D"];
        const timeFormats = ["h:mm a", "h:mm A", "H:mm", "h:mm:ss a", "ha", "HH:mm:ss", "HH:mm"];
        for (let i = 0; i < dateFormats.length; i += 1) {
            _validDateFormats.push(dateFormats[i]);
            for (let j = 0; j < timeFormats.length; j += 1) {
                _validDateFormats.push(timeFormats[j]);
                _validDateFormats.push(dateFormats[i] + " " + timeFormats[j]);
            }
        }
        _validDateFormats.push("dddd, MMMM Do, YYYY h:mm:ss a");
        return _validDateFormats;
    }
}

export function parseMoment(value, isUtc?: boolean): moment.Moment {
    if (value) {
        if (value instanceof Date)
            return moment(value);
        else if (moment.isMoment(value))
            return value;
        if (isUtc === true) {
            return moment.utc(value, getDateFormats());
        }
        return moment(value, getDateFormats());
    }
    return null;
}

export type dateFormatValue = "date" | "datetime" | "time" | "isodate" | "isodatetime" | "isotime" | "isodatetime2" | "fulldatetime";
export function formatDateToString(value, dateType?: dateFormatValue): string {
    const momentVal = parseMoment(value);
    if (dateType === undefined) {
        dateType = "datetime";
    }
    dateType = (dateType.toLowerCase() as string) as dateFormatValue;
    if (dateType === "date") {
        return momentVal.format("MM/DD/YYYY");
    }
    else if (dateType === "time") {
        return momentVal.format("hh:mm:ss a");
    }
    else if (dateType === "isodate") {
        return momentVal.format("YYYY-MM-DD");
    }
    else if (dateType === "isodatetime") {
        return momentVal.format("YYYY-MM-DDTHH:mm:ss");
    } else if (dateType === "isotime") {
        return momentVal.format("HH:mm:ss");
    } else if (dateType === "isodatetime2") {
        return momentVal.format("YYYY-MM-DDTHH:mm");
    } else if (dateType === "fulldatetime") {
        return momentVal.format("MM/DD/YYYY hh:mm:ss a");
    } else {
        return momentVal.format("MM/DD/YYYY hh:mm a");
    }
}



export function coerceDateValue(value, dateType?: dateFormatValue, setSecondsToZero?: Boolean): string {
    let date: moment.Moment;
    if (moment.isMoment(value)) {
        date = value;
    } else {
        date = parseMoment(value);
    }
    if (date && date.isValid()) {
        if (setSecondsToZero) {
            date.seconds(0); //Always set seconds to 0 to handle iOS setting to the same as its system clock
        };
        return formatDateToString(date, dateType);
    }
    return "";
};



export function stringStartsWith(string: string, startsWith: string): boolean {
    string = string || "";
    if (startsWith.length > string.length)
        return false;
    return string.substring(0, startsWith.length) === startsWith;
};

export function isDate(value) {
    return ((typeof (value) === "object" && value.constructor.toString().match(/date/i) !== null));
}

export function isNumber(value) {
    return !isNaN(parseInt(String(value)));
}


export function setDateValue(value) {
    //console.log(`Parsing date value of ${value}`)
    if (isJsonDate(value)) {
        value = parseJsonDate(value);
        if (value !== null && isDate(value)) {
            value = formatDateToString(value);
        }
    }
    else if (value) {
        const dt = parseMoment(value);
        if (dt !== null && dt.isValid()) {
            value = formatDateToString(dt);
        }
    }
    //console.log(`Returning parsed date value of ${value}`);
    return value;
}

(String as any).prototype.equalsIgnoreCase = function (arg) {
    return (new String(this.toLowerCase()).valueOf() === (new String(arg)).toLowerCase().valueOf());
}

export function simpleFormat(title: string) {
    if (!title) {
        return title;
    }
    return title.toLowerCase().replace(/[^a-z0-9_-]/g, "_").replace(/_-_/g, "_");
};

var atlasInternalIdCounter = 0;
export function createIdPrefix() {
    atlasInternalIdCounter = atlasInternalIdCounter + 1;
    return "a" + atlasInternalIdCounter;
}

String.prototype.equalsIgnoreCase = function (arg) {
    return (new String(this.toLowerCase()).valueOf() === (new String(arg)).toLowerCase().valueOf());
}

function addSerializedValue(seralizationContainer, namePrefix, propertyName, propertyValue) {
    const value = propertyValue === null ? "" : propertyValue;
    const input = $("<input type='hidden'/>");
    input.attr("name", namePrefix + propertyName);
    input.val(value);
    seralizationContainer.append(input);
}

export function serializeToForm(fieldNamePrefix, targetContainer, dataToSerialize) {
    for (const prop in dataToSerialize) {
        if (dataToSerialize.hasOwnProperty(prop)) {
            if (!$.isArray(dataToSerialize[prop])) {
                addSerializedValue(targetContainer, fieldNamePrefix, prop, dataToSerialize[prop]);
            } else {
                $.each(dataToSerialize[prop], (childIndex: any, child) => {
                    serializeToForm(fieldNamePrefix + prop + "[" + childIndex + "].", targetContainer, child);
                });
            }
        }
    }
}

export function parseFqdnToNetIdRealmPair(fqdn: string): INetIdRealmPair {
    const at = fqdn.indexOf("@");
    const cn = fqdn.substr(0, at);
    const realm = fqdn.substr(at + 1);
    return { CN: cn, Realm: realm } as INetIdRealmPair;
}

//Format search text for lunr's syntax
export function formatSearchTextForLunr(text: string): string {
    //console.log(text);
    if (!text) {
        return text;
    };
    let retVal = text;
    //Handle quoted strings
    var quoatedTextRegEx = new RegExp('["][^"]*["]', 'g');  //Find quoted strings
    var quotedStrings = retVal.match(quoatedTextRegEx);
    if (quotedStrings) {
        quotedStrings.forEach((value, index) => {
            //console.log("Quoted string: " + value);
            let lunrString = value.trim().replace(/["]/g, '').trim(); //remove quotes
            lunrString = lunrString.replace(/\s+/g, ' +'); //add + sign before each word
            if (lunrString.length > 0) {
                lunrString = "+" + lunrString; //add + to beginning
            };
            //console.log("lunr String: " + lunrString);
            retVal = retVal.replace(value, lunrString);  //replace return text with new
        });
    };
    //Handle words joined by 'and'
    var andRegEx = /[^\s]+(\s+and\s+[^\s]+)+/gi; //Find strings that are join by 'and' like 'foo and bar' or 'foo and bar and foobar'
    var wordsConnectedWithAnd = retVal.match(andRegEx);
    if (wordsConnectedWithAnd) {
        wordsConnectedWithAnd.forEach((value, index) => {
            //console.log("Connected with 'and': " + value);
            let lunrString = value.trim().replace(/\s+and\s+/gi, ' '); //remove 'and' and surounding whitespace. replace with space
            //console.log("And removed: " + lunrString);
            lunrString = lunrString.replace(/ (?!\+)/gi, ' +'); //match space not followed by a plus and replace with space and plus
            if (!lunrString.startsWith("+")) { //add starting +
                lunrString = "+" + lunrString;
            }
            //console.log("lunr string: " + lunrString);
            retVal = retVal.replace(value, lunrString); //replace the found string with lunr formatted one
        });
    }
    //console.log("lunr formatted search string: " + retVal);
    return retVal;
};